import React, {Component} from 'react'
import {Table} from 'semantic-ui-react'

export default class KeyValue extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        const pair = this.props.pair;

        const keyValue = Object.keys(pair).map((element, index) =>
            <tr key={index}>
                <td>{element}</td>
                <td>{String(pair[element])}</td>
            </tr>
        );

        return (
            <Table definition>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell>Value</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {keyValue}
                </Table.Body>
            </Table>
        )
    }
}